'use strict'

const AES_Crypto = require('./lib/aes_crypto')

module.exports.AES_Crypto = AES_Crypto

